import config from 'config';
import tmpl from './index.phtml';
import View from 'lib/View';
import * as repo from 'db/repositories';


export default View.extend({
	template: tmpl,

	initialize: function()
	{
		this.listenTo( app, 'synched', this.render );
		this.listenTo( app, 'authenticated', this.render );
		this.listenTo( app.getStore('user'), 'sync update fetch set reset', this.render );
		this.listenTo( app.getStore('data'), 'sync update fetch set reset', this.render );
	},

	render: _.throttle( function()
	{
		var self = this;
		var uid = app.getStore('user').get('uuid');
		var userId = app.getStore('user').get('id');

		repo.getHomeCounts( uid, userId ).then( function( counts )
		{
			self.doRender( _.extend( {
				user: self.model,
				data: app.getStore('data'),
			}, counts ) );
		} );
	}, 200, { leading: false } ),

	unload: function()
	{
		this.stopListening();
		this.render.cancel();
		this.doUnload();
	},
});
